import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { sessionService } from '../../service/session.service';
import { facultyService } from '../../service/faculty.service';
import { commonService } from '../../service/common.service';
import { userService } from '../../service/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers:[sessionService,facultyService,userService]
})
export class ProfileComponent implements OnInit {
  faculty:any;
  user:any;
  userId:any;
  msg:any;
  isSuccess=false;
  isError=false;
  path:any;
  profileUrl:any;
  constructor(private global: Globals,private _user:userService,public router: Router,private _session:sessionService,private _faculty:facultyService,private _common:commonService,private frmBuilder: FormBuilder,private route: ActivatedRoute) {
    
   this.user=_common.user;;
  this.path=this.global.siteUrl+this.global.profileFolder+'/';
  this.profileUrl=this.global.profileUrl;
  }

  ngOnInit() {
    window.scrollTo(0, 0);
/*
    this.route.params.subscribe((params: Params) => {
      if(params['id']){  
        this.userId=decodeURIComponent(atob(params['id']));
        this._faculty.facultyprofile(this.userId).subscribe((data : any)=>{
          if(data.error==0){
            this.faculty=data.results;
            if(data.results.photo!='' && data.results.photo!=null){
              this.path=this.path+data.results.photo;
            }else{
              this.path=this.path+'avatar.png';
            }
            
            
          }
          else{
            if(data.message=="Failed to authenticate token."){
              this.router.navigate(['/']);
            }else{
            this.msg = data.message;
            this.isError = true;
            this.router.navigate(['/']);
            }
          }
          
        })
        }
      
      });
*/
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/profile/profile.component.ts